import React, { useState, useEffect } from 'react';
import { Radio } from 'antd';
interface ExteriorOption {
  code: string | boolean,
  label: string,
  disabled?: boolean
}
interface Option {
  label: string;
  value: string | boolean;
  disabled?: boolean
}
export interface Props {
  // defaultValue?: string[],
  width?: number | string,
  disabled?: boolean,
  defaultValue?: any,
  options?: ExteriorOption[],
  value?: any;// 目前form表单联动使用
  onChange?: (value: any) => void;// 目前form表单联动使用
  optionType?: 'default' | 'button'
  buttonStyle?: 'outline' | 'solid'
}
const EncCheckbox = ({
  disabled,
  defaultValue,
  width,
  options = [],
  value,
  onChange,
  optionType = 'default',
  buttonStyle = 'outline'
}: Props) => {
  const [SelectOptions, setSelectOptions] = useState<Option[]>([]);
  useEffect(() => {
    if (options && options.length) {
      setSelectOptions(options.map(v => ({
        ...v,
        value: v.code
      })))
    }
  }, [options]);
  const triggerChange = (val: any) => {
    window.console.log(val)
    onChange?.(val);
  }

  return (
    <Radio.Group
      disabled={disabled}
      defaultValue={defaultValue}
      value={value}
      onChange={triggerChange}
      options={SelectOptions}
      optionType={optionType}
      buttonStyle={buttonStyle}
      style={{ width: width || '100%' }} />
  )
}

export default EncCheckbox
